import React, { Component } from 'react'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

import './index.scss'

class QlikTsbvisitorquery extends Component {

  constructor(props) {
    super(props)
    this.mobileWidth = 0
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const url = "https://qlik.unifi.id/external-ticket-authentication/single/?appid=1543d9b3-9b5c-4e6a-aee8-ffe3789362dc&sheet=3ec15e07-e6b0-48b6-a88d-05ce44198fcc&opt=currsel%2Cctxmenu&select=clearall"
    return (
      <PageContainer>
        <iframe src={url} />
      </PageContainer>
    )
  }
}

export default userIsAuthenticatedRedir(QlikTsbvisitorquery)



// WEBPACK FOOTER //
// ./src/pages/qlik-reports/tsb/visitorquery/index.js